import {useContext} from 'react';
import Modal from 'react-bootstrap/Modal';
import { ButtonPrimary } from '../../../common/components';
import { useEffect } from 'react';
import { TagManager } from '../../utils/analytics/TagManager';
import * as colors from '../../../common/styles/colors';
import { UserDetailContext, UserDetailContextProps } from '../../../context/userDetail/userDetailContext';

type HHDataRequestSuccessModalProps = {
  meterType: Common.IOption;
  onHide: () => void;
  show: boolean;
};

const defaultProps = {
  show: false,
};

export const HHDataRequestSuccessModal = (props: HHDataRequestSuccessModalProps) => {
  const { userDetail } = useContext<UserDetailContextProps>(UserDetailContext);
  const { show } = props;
  const convertMeterTypeToText = (meterType: string) => {
    switch (meterType) {
      case 'HalfHourly':
        return 'HH';
      case 'Smart':
        return 'Smart meter';
      case 'AutomaticMeterRead':
        return 'AMR';
      default:
        return meterType;
    }
  };

  const title = `${convertMeterTypeToText(props.meterType.value)} data requested`;

  useEffect(() => {
    if (show) {
      TagManager.pushData({
        event: 'HH data request success',
        customerAccountReference: userDetail.essCustomerId
      });
    }
  }, [show]);

  const handleClose = (event: any) => {
    event.preventDefault();
    props.onHide();
  };

  return (
    <>
      <Modal animation={false} className={'custom-modal'} show={show} backdrop='static' centered>
        <Modal.Header style={{ justifyContent: 'center', textAlign: 'center', color: colors.hydroBlue }}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ justifyContent: 'center', textAlign: 'center' }}>
          <div>
            <p>Thank you for your request.</p>
            <p>
              Depending on the size of your request, it could take us up <br />
              to 24 hours to deliver the data.
            </p>
            <p>
              We'll let you know via email when the data's available - <br />
              you'll then be able to access it via 'Messages' once you've logged in.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className='p-0'>
          <ButtonPrimary onClick={handleClose} title='OK' className='mt-3 mr-0' />
        </Modal.Footer>
      </Modal>
    </>
  );
};

HHDataRequestSuccessModal.defaultProps = defaultProps;
